// extracted by mini-css-extract-plugin
export default {"homeSectThree":"SectionThree_homeSectThree__+ODjI"};